import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=11e90286&"
import script from "./Copy.vue?vue&type=script&lang=js&"
export * from "./Copy.vue?vue&type=script&lang=js&"
import style0 from "./Copy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports